// ImageUpload.js
import React, { useState, useRef } from "react";
import ImagePreview from "./ImagePreview";
import HeaderLogo from "../../components/Logo/HeaderLogo";
import { addDefaultImg } from "../../utils/common-methods";
//import "./ImageUpload.css";

const ImageUpload = ({
  title,
  onUpload,
  maxSize,
  validTypes,
  isCover = false,
  imageURL,
}) => {
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(imageURL);
  const [errorMessage, setErrorMessage] = useState("");
  const hiddenFileInput = useRef(null);

  // Handle image selection
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    let newErrorMessage = "";
    if (file) {
      if (!validTypes.includes(file.type)) {
        newErrorMessage = `File "${
          file.name
        }" is not a valid image type. Allowed types: ${validTypes.join(", ")}`;
      } else if (file.size > maxSize) {
        newErrorMessage = `File "${
          file.name
        }" exceeds the maximum size of ${maxSize / (1024 * 1024)}MB.`;
      } else {
        const reader = new FileReader();

        reader.onloadend = () => {
          setImage(file);
          setImagePreview(reader.result);
        };

        reader.readAsDataURL(file);
      }
      setErrorMessage(newErrorMessage);
    }
  };

  // Handle image upload
  const handleUpload = async () => {
    if (image && onUpload) {
      const formData = new FormData();
      formData.append("image", image);

      try {
        // Assuming `onUpload` is a function that handles the upload to your server.

        await onUpload(formData);
        //alert("Image uploaded successfully!");
        return formData;
      } catch (error) {
        //alert("Error uploading image");
      }
    }
  };
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  //width: "250px", was removed from  <div style={{  textAlign: "center", margin: "auto auto" }}>
  return (
    <section className="loginswallow">
      <div className="form-container" id="form-container">
        <div style={{ textAlign: "center", margin: "auto auto" }}>
          <HeaderLogo></HeaderLogo>
        </div>
        <h5>Upload Image</h5>
        <p>Add pictures to your profile to highlight.</p>

        {imagePreview && (
          <div style={{ textAlign: "center" }}>
            <img
              src={imagePreview}
              width="100%"
              height="auto"
              alt="noimage"
              onError={addDefaultImg}
            ></img>
            {/* <ImagePreview
              src={imagePreview}
              width="100%"
              height="auto"
              style={{
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                BorderAll: "dark",
                boxshadow: "green",
              }}
            /> */}
          </div>
        )}
        {errorMessage && <p className="text-danger mt-3">{errorMessage}</p>}
        <div style={{ margin: "20px", textAlign: "center" }}>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            ref={hiddenFileInput}
            style={{ display: "none" }}
            //style={{ padding: "10px", cursor: "pointer" }}
            id="file-input"
          />
        </div>

        <hr></hr>

        <div style={{ marginTop: "10px", textAlign: "center" }}>
          <button
            className="button-upload"
            onClick={handleClick}
            style={{ width: "180px", marginRight: "10px" }}
          >
            Select a file
          </button>

          {image && (
            <button onClick={handleUpload} style={{ width: "180px" }}>
              Upload Image
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default ImageUpload;
